module.exports = __webpack_public_path__ + "static/img/nodata.b9ebc296.png";